// @ts-nocheck
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ProcessForm } from "./ProcessForm";
import { generateProcessStepCode } from "./process-stage-machines.helper";
import { trpcClient } from "@/lib/trpc";
import { toast } from "sonner";
import { useQueryClient } from "@tanstack/react-query";

interface ProcessCreateModalProps {
  open: boolean;
  onClose: () => void;
  onCreated?: (newProcessId: string) => void;
  initialName?: string;
  initialGroupKey?: string;
}

export function ProcessCreateModal({
  open,
  onClose,
  onCreated,
  initialName,
  initialGroupKey,
}: ProcessCreateModalProps) {
  const queryClient = useQueryClient();

  const handleSubmit = async (data: any) => {
    try {
      const res = await trpcClient.technical.processes.create.mutate(data);

      await queryClient.invalidateQueries({ queryKey: ["processes"] });
      await queryClient.invalidateQueries({ queryKey: ["processes-lookup"] });
      await queryClient.invalidateQueries({ queryKey: ["combobox"] });

      if (onCreated && res.id) {
        onCreated(res.id);
      }
      onClose();
    } catch (error: any) {
      toast.error(`Lỗi tạo công đoạn: ${error.message || "Unknown"}`);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="sm:max-w-[90vw] md:max-w-[720px] max-h-[90vh] overflow-y-auto w-full p-6"
        // Bấm ra ngoài / Esc không đóng form, tránh mất dữ liệu đang nhập (FB-9CCX55)
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-slate-800">
            Thêm mới công đoạn
          </DialogTitle>
          <DialogDescription className="text-xs text-slate-500">
            Nhập tên công đoạn để sử dụng ngay; mã công đoạn và định mức kỹ thuật được tự động khởi tạo chuẩn xưởng.
          </DialogDescription>
        </DialogHeader>
        <div className="-mx-2 px-2 pb-2">
          {open && (
            <ProcessForm
              isQuickModal
              lockedGroup={Boolean(initialGroupKey)}
              onSuccess={handleSubmit}
              onCancel={onClose}
              defaultValues={{
                name: initialName || "",
                group: initialGroupKey || "",
                stepId: initialName
                  ? generateProcessStepCode(initialName, initialGroupKey)
                  : "",
              }}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
